<template>
  <div>
    <el-card shadow="always">
      <EditForm
        ref="editForm"
        :disabled="disabled"
        :isAudit="isAudit"
        :pdCostsOrderCode="pdCostsOrderCode"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'plan-pdCostsOrder-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pdCostsOrderCode() {
      return this.params.pdCostsOrderCode
    },
    disabled() {
      return this.pageType === 'detail' || this.pageType === 'audit'
    },
    isAudit() {
      return this.pageType === 'audit'
    },
  },
}
</script>
